export default __webpack_public_path__ + "static/media/csv@2x.6581c6c3.png";